import { render, staticRenderFns } from "./StreamplayList.vue?vue&type=template&id=fcdedfc0&scoped=true"
import script from "./StreamplayList.vue?vue&type=script&lang=js"
export * from "./StreamplayList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcdedfc0",
  null
  
)

export default component.exports